
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"layout","x":"0","y":"0","fill":"#fff","xml:space":"preserve","width":"250","height":"60.2","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"g53","transform":"translate(-264.801 -258.157) scale(.92664)"}},[_c('path',{staticClass:"st0",attrs:{"d":"M441.7 306c2.5-2.4 4-5.8 4-9.5 0-7.2-5.8-13.1-13-13.2h-14.6v45.4h14.6c7.2-.1 13-6 13-13.2 0-3.7-1.5-7.1-4-9.5zm-16-15.1h6.8c3.1 0 5.7 2.5 5.7 5.7s-2.5 5.7-5.6 5.7h-6.8zm6.8 30.3h-6.8v-11.3h6.8c3.1 0 5.6 2.5 5.6 5.7s-2.5 5.6-5.6 5.6zm75.4-37.8h-9.5l-9 26.5v18.9h7.6v-11.3h12.5v11.3h7.6v-18.9zm-4.8 9.4l5.8 17h-11.6zm47.3-6.6L540 309.8v18.9h-7.6v-18.9L522 286.2v-2.8h7l7.2 16.3 7.2-16.3h7zm-179.5 29.1c0 7.8-6.4 14.2-14.2 14.2-7.8 0-14.2-6.4-14.2-14.2v-5.5h7.6v5.5c0 3.6 3 6.6 6.6 6.6 3.6 0 6.6-3 6.6-6.6v-31.9h7.6zm23.6-32.7c-7.8 0-14.2 6.4-14.2 14.2v18.5c0 7.8 6.4 14.2 14.2 14.2 7.8 0 14.2-6.4 14.2-14.2v-18.5c0-7.8-6.4-14.2-14.2-14.2zm6.6 14.2v18.5c0 3.6-3 6.6-6.6 6.6-3.6 0-6.6-3-6.6-6.6v-18.5c0-3.6 3-6.6 6.6-6.6 3.6 0 6.6 3 6.6 6.6zm68.6-13.4h-13.8v45.4h7.6V311h6.2c7.6 0 13.8-6.2 13.8-13.8 0-7.6-6.2-13.8-13.8-13.8zm0 20h-6.2v-12.5h6.2c3.4 0 6.2 2.8 6.2 6.2 0 3.4-2.8 6.3-6.2 6.3z","id":"path49"}}),_c('path',{staticClass:"st0",attrs:{"d":"M327.4 341h-35.9v-7.6h35.9zm-7.4-33.2l-6.8 8.7v-33.1h-7.6v33.1l-6.8-8.7h-7.4v2.8l14.2 18.1h7.6l14.2-18.1v-2.8z","id":"path51"}})])])
          )
        }
      }
    